import clsx from 'clsx';

import type { BoxProps } from '../../Box/Box';
import { Box } from '../../Box/Box';

import { head } from './styles.css';

export interface Props extends Omit<BoxProps, 'cssClass'> {
  children: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
  reserveScrollbarSpace?: boolean;
}

export const Head: React.FC<Props> = ({ children, className, style, reserveScrollbarSpace, ...boxProps }) => (
  <Box
    cssClass={clsx(head, className)}
    style={{
      ...(reserveScrollbarSpace && {
        scrollbarGutter: 'stable',
        overflowY: 'auto',
      }),
      ...style,
    }}
    {...boxProps}
  >
    {children}
  </Box>
);
